import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
const CONSENT_KEY = 'cavalla.consent';
export function ConsentBanner() {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    try {
      if (!window.localStorage.getItem(CONSENT_KEY)) {
        const timer = window.setTimeout(() => setVisible(true), 900);
        return () => window.clearTimeout(timer);
      }
    } catch {
      /* storage unavailable, do not block the page */
    }
    return undefined;
  }, []);
  const decide = (choice: 'all' | 'essential') => {
    try {
      window.localStorage.setItem(CONSENT_KEY, choice);
    } catch {
      /* nothing further to do */
    }
    setVisible(false);
  };
  if (!visible) return null;
  return <div role="dialog" aria-labelledby="consent-title" aria-modal="false" className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white p-5 shadow-[0_-8px_24px_rgba(11,37,71,0.08)] sm:p-6" data-id="element-90" data-mp="2d8hnw6y9szij">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 lg:flex-row lg:items-center lg:justify-between" data-id="element-91" data-mp="1u8veic0g2mua">
        <div className="max-w-2xl" data-id="element-92" data-mp="1z7gf4cjlz8j9">
          <h2 id="consent-title" className="font-display text-[18px] text-ink" data-id="element-93" data-mp="1zakorpfuewhb">
            Your choice on cookies
          </h2>
          <p className="mt-2 text-[14px] text-body" data-id="element-94" data-mp="1pieyql95ip4r">
            We use essential cookies to run this site. Analytics and marketing cookies are only set if you
            accept them. You can change your mind at any time. Read our{' '}
            <Link to="/legal/cookies" className="underline underline-offset-2 hover:text-royal" data-id="element-95" data-mp="1flab0gznqllu">
              cookie notice
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-3 sm:flex-row" data-id="element-96" data-mp="16j137yvrx6c5">
          <Button variant="secondary" size="sm" onClick={() => decide('essential')} data-id="element-97" data-mp="2vyqygqrmgf2g">
            Essential only
          </Button>
          <Button size="sm" onClick={() => decide('all')} data-id="element-98" data-mp="30y3jd5yxnc2e">
            Accept all
          </Button>
        </div>
      </div>
    </div>;
}